



































import Vue from 'vue';
import pipeline from '@/pipeline';
import IdentificationDocumentForm, {
  IdentificationDocumentFormEvent,
} from '@/components/forms/studentData/IdentificationDocumentForm.vue';
import PipelineMenu from '@/components/PipelineMenuWrapper.vue';
import BottomButton from '@/components/BottomButton.vue';
import BackButton from '@/components/BackButton.vue';
import { IdentificationDocument } from '@/store/modules/studentData/state';
import { AutocompleteOption, parseToAutocompleteOptionArray } from '@/helpers/autocomplete';

export default Vue.extend({
  components: {
    BackButton,
    BottomButton,
    IdentificationDocumentForm,
    PipelineMenu,
  },
  data() {
    return {
      form: {
        rg: this.$store.getters.identificationDocument?.rg || '',
        issueDate: this.$store.getters.identificationDocument?.issueDate || '',
        issuer: this.$store.getters.identificationDocument?.issuer || '',
        issueState: this.$store.getters.identificationDocument?.issueState || '',
        motherName: this.$store.getters.identificationDocument?.motherName || '',
        fatherName: this.$store.getters.identificationDocument?.fatherName || '',
      },
      hasErrors: false,
      isContinueDisabled: false,
    };
  },
  computed: {
    isContinueEnabled(): boolean {
      const { fatherName, ...allFieldsExceptFatherName } = this.form;
      return !this.hasErrors && Object.values(allFieldsExceptFatherName).every(Boolean);
    },
    issueStateOptions(): string[] {
      return this.$store.getters.issueStateOptions || [];
    },
    issuerOptions(): AutocompleteOption[] {
      return parseToAutocompleteOptionArray(this.$store.getters.issuerOptions) || [];
    },
  },
  created() {
    this.$store.dispatch('PULL_ISSUER_OPTIONS');
    this.$store.dispatch('PULL_ISSUE_STATE_OPTIONS');
  },
  methods: {
    async continueHandler(): Promise<void> {
      this.isContinueDisabled = true;
      try {
        const identificationDocument: IdentificationDocument = this.form;

        await this.$store.dispatch('UPDATE_IDENTIFICATION_DOCUMENT', { identificationDocument });

        pipeline.next();
      } finally {
        this.isContinueDisabled = false;
      }
    },
    inputHandler(event: IdentificationDocumentFormEvent, hasErrors: boolean) {
      this.hasErrors = hasErrors;
      this.form = event;
    },
  },
});
